import { isApiError } from '@/api/errors';

/**
 * Content permissions: what a partner key may hold only in OPERATOR mode (decision 004).
 *
 * Used only to group the checklist and to show the content group while it is unavailable. What a
 * key may actually hold is always `allowed_key_permissions` / `available_permissions` from the API.
 */
const CONTENT_PERMISSIONS: readonly string[] = [
  'accounts:read',
  'accounts:write',
  'comments:read',
  'comments:write',
  'media:write',
  'messages:read',
  'messages:write',
  'posts:read',
  'posts:write',
  'webhooks:write',
  'workspaces:write',
];

export function isContentPermission(permission: string): boolean {
  return CONTENT_PERMISSIONS.includes(permission);
}

export function knownContentPermissions(): readonly string[] {
  return CONTENT_PERMISSIONS;
}

/** Permissions a key holds that its owner's current set no longer allows. */
export function driftedPermissions(held: readonly string[], allowed: readonly string[]): string[] {
  return held.filter((permission) => !allowed.includes(permission));
}

/** The message the API attaches to `permissions` when it refuses a permission list, if any. */
export function permissionsFieldError(error: unknown): string | undefined {
  if (!isApiError(error)) return undefined;
  return error.fieldErrors.find((entry) => entry.field === 'permissions')?.message;
}
